// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-6ba2f4fc] {\n    margin-top: 2em;\n}\n.training-resource-container[data-v-6ba2f4fc] {\n    width: 95%;\n    height: 100vh;\n    margin: auto;\n    padding: 10px;\n}\n.side-menu[data-v-6ba2f4fc] {\n    background: #F8F8F8\t;\n    width: 18%;\n    float: left;\n    padding-top: 10px;\n}\n.resource-list[data-v-6ba2f4fc]  {\n    margin-left: 21%;\n    height: 100vh;\n}\n", ""]);
// Exports
module.exports = exports;
